import { render, staticRenderFns } from "./Design.vue?vue&type=template&id=2393e88b&scoped=true"
import script from "./Design.vue?vue&type=script&lang=js"
export * from "./Design.vue?vue&type=script&lang=js"
import style0 from "./Design.vue?vue&type=style&index=0&id=2393e88b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2393e88b",
  null
  
)

export default component.exports